import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function GazPage() {
  return <ServicePage data={servicesData.gaz} />;
}
